import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import authService from '../services/authService';
import { trackEvent } from '../utils/analytics';
import { ErrorMessage } from './common';
import './Auth.css';

function VerifyEmail() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get('token');

      if (!token) {
        trackEvent('verify_email_failed', { reason: 'token_not_found' });
        setStatus('error');
        setError(t('auth.verifyEmail.tokenNotFound'));
        return;
      }

      try {
        const response = await authService.verifyEmail(token);
        trackEvent('verify_email_success');
        setStatus('success');
        setMessage(response.message);
      } catch (err) {
        trackEvent('verify_email_failed', { reason: 'server_error' });
        setStatus('error');
        setError(err.response?.data?.message || t('auth.verifyEmail.error'));
      }
    };

    verifyToken();
  }, [searchParams, t]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{t('auth.verifyEmail.title')}</h2>

        {status === 'loading' && (
          <div className="verify-status">
            <div className="loading-spinner"></div>
            <p>{t('auth.verifyEmail.loading')}</p>
          </div>
        )}

        {status === 'success' && (
          <div className="verify-status success">
            <div className="status-icon">&#10004;</div>
            <p>{message}</p>
            <Link to="/login" className="btn btn-primary">
              {t('auth.verifyEmail.success')}
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="verify-status">
            <ErrorMessage message={error} />
            <div className="auth-links">
              <Link to="/login" className="link-button">
                {t('auth.verifyEmail.toLogin')}
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
